import moment from 'moment'

export const getCallsForPeriod = ({ callsRaw, periodValue, periodUnit }) => {
  // Filter data by ther period of interest
  const callsFormatted = callsRaw
    ? callsRaw.map(item => ({ ...item, dateTime: moment(item.dateTime) }))
    : []
  const calls = callsFormatted.filter(
    call => call.dateTime >= moment().subtract(periodValue, periodUnit)
  )
  const callsPrevious = callsFormatted.filter(
    call =>
      call.dateTime > moment().subtract(2 * periodValue, periodUnit) &&
      call.dateTime < moment().subtract(periodValue, periodUnit)
  )
  return {
    calls,
    callsPrevious,
  }
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/utils/getCallsForPeriod.ts